export default "__VITE_ASSET__010c477a__"